import React, { FunctionComponent, useState } from 'react';
import Translate from 'ui/atoms/translate';
import Button from 'ui/atoms/button';
import ServerError from 'ui/types/server-error';
import makeForm from 'ui/forms';
import ActionButtons from 'ui/molecules/action-buttons';
import Section from 'src/ui/atoms/section';
import { StateValues } from 'react-use-form-state';
import { TaxInformation } from 'src/api';
import { FileWithDocType } from 'src/ui/atoms/file-upload';

export interface TaxInformationFields {
  taxIdentificationNumber: string;
  isSubjectToGermanTax: boolean;
  hasNonAssessmentCertificate: boolean;
  nonAssessmentCertificate?: FileWithDocType;
}

export interface TaxInformationProps {
  currentTaxInformation: TaxInformation | null | undefined;

  onSubmit?: (values: TaxInformationFields) => void;

  loading?: boolean;

  error?: ServerError;

  isRegisterOnlyFlow?: boolean;
}

export const Form = makeForm<TaxInformationFields>();

const TaxInformationForm: FunctionComponent<TaxInformationProps> = (props) => {
  const { currentTaxInformation, onSubmit = () => {}, loading, error, isRegisterOnlyFlow, ...restProps } = props;

  const [hasNonAssessmentCertificate, setHasNonAssessmentCertificate] = useState(false);

  return (
    <div {...restProps}>
      <Form
        onSubmit={onSubmit}
        error={error}
        onChange={(values: StateValues<TaxInformationFields>) => {
          setHasNonAssessmentCertificate(values.hasNonAssessmentCertificate);
        }}
        initial={{
          taxIdentificationNumber: currentTaxInformation?.taxIdentificationNumber,
          isSubjectToGermanTax: currentTaxInformation?.isSubjectToGermanTax,
          hasNonAssessmentCertificate: currentTaxInformation?.nonAssessmentCertificate,
        }}
        i18nKey="taxInformationForm"
      >
        <Section spacing="large">
          <>
            <h4>
              <Translate name="taxInformation.taxAndResidency" />
            </h4>
            <Form.Group name="taxIdentificationNumber" required={true}>
              <Form.Input maxLength={100} />
            </Form.Group>
            <Form.Group name="isSubjectToGermanTax" label={null}>
              <Form.Checkbox>
                <Translate name="taxInformationForm.fields.isSubjectToGermanTax.label" />
              </Form.Checkbox>
            </Form.Group>
            <h4>
              <Translate name="taxInformation.nonAssessmentCertificate" />
            </h4>
            <Form.Group name="hasNonAssessmentCertificate" label={null}>
              <Form.Checkbox>
                <Translate name="taxInformationForm.fields.hasNonAssessmentCertificate.label" />
              </Form.Checkbox>
            </Form.Group>

            {hasNonAssessmentCertificate && (
              <>
                <h4>
                  <Translate name="taxInformationForm.fields.nonAssessmentCertificate.label" />
                </h4>
                <Form.Group name="nonAssessmentCertificate" required={hasNonAssessmentCertificate} label={null}>
                  <Form.FileUpload />
                </Form.Group>
              </>
            )}
          </>
        </Section>
        <ActionButtons>
          <Button variant="primary" type="submit" size="large" fluid={true} loading={loading}>
            <Translate name="common.continue" />
          </Button>
        </ActionButtons>
      </Form>
    </div>
  );
};

export default TaxInformationForm;
